import { render, staticRenderFns } from "./CustomerBanner.vue?vue&type=template&id=6a6f4786&scoped=true"
import script from "./CustomerBanner.vue?vue&type=script&lang=js"
export * from "./CustomerBanner.vue?vue&type=script&lang=js"
import style0 from "./CustomerBanner.vue?vue&type=style&index=0&id=6a6f4786&prod&lang=scss&scoped=true"
import style1 from "./CustomerBanner.vue?vue&type=style&index=1&id=6a6f4786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6f4786",
  null
  
)

export default component.exports